import { render, staticRenderFns } from "./wine-rep-sales.vue?vue&type=template&id=4e6067d5&scoped=true&"
import script from "./wine-rep-sales.vue?vue&type=script&lang=js&"
export * from "./wine-rep-sales.vue?vue&type=script&lang=js&"
import style0 from "./wine-rep-sales.vue?vue&type=style&index=0&id=4e6067d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6067d5",
  null
  
)

export default component.exports